import { generateUUID, getTemporaryBlockId } from "../../../../../../../services/helpers/Helper";
import { CARDS } from "./constants";

const Cards = (props) => {
   const { faq, data, onChange, faqId } = props;

   const handleAddCard = (obj) => {
      if (onChange) {
         obj = {
            ...obj,
            temporary_block_id: generateUUID()
         }
         let newData = data;
         if (getTemporaryBlockId(newData.first_block) === faqId) {
            newData.first_block = { ...faq, cards: [...faq.cards, obj] };
         }
         newData.blocks = newData.blocks.map(m => {
            if (getTemporaryBlockId(m) === faqId) {
               return { ...faq, cards: [...faq.cards, obj] }
            }
            return m;
         });
         onChange(newData);
      }
   }
   return (
      <div className="add-card-editor">
         <div className="add-card-container p-l20 p-r20">
            {CARDS.map((item, index) => (
               <div className="add-card-item " title={item.name} key={index} onClick={() => handleAddCard(item.value)}>
                  <div className="add-card-icon">
                     {item.icon}
                  </div>
                  <div className="add-card-title text-smaller">
                     <span>{item.name}</span>
                  </div>
               </div>
            ))}
         </div>
      </div>
   )
}

export default Cards;